module.exports = __webpack_public_path__ + "img/ttchainLogoGreen.bf48d320.png";